/**
 * Helpers para manejo de autenticación con OIDC
 */

/**
 * Realiza el logout del usuario de forma segura
 * Maneja casos donde el proveedor OIDC no tiene endpoint de logout
 *
 * @param {Object} auth - Objeto auth de useAuth() hook
 * @returns {Promise<void>}
 */
export const performLogout = async (auth) => {
  try {
    // Limpiar todo el SessionStorage
    sessionStorage.clear();

    // Intentar cerrar sesión con el proveedor OpenID
    // Si el proveedor no tiene endpoint de logout (end_session_endpoint), esto fallará
    await auth.signoutRedirect();
  } catch (error) {
    console.warn("No se pudo cerrar sesión con el proveedor OIDC:", error.message);
    console.info("Realizando logout local...");

    // Si falla (por ejemplo, no hay endpoint de logout), hacer logout local
    auth.removeUser();

    // Redirigir manualmente al login
    window.location.href = "/";
  }
};

/**
 * Obtiene el token de acceso desde SessionStorage
 *
 * @returns {string|null} Token de acceso o null si no existe
 */
export const getAccessToken = () => {
  return sessionStorage.getItem("token_TSE");
};

/**
 * Guarda el token de acceso en SessionStorage
 *
 * @param {string} token - Token de acceso
 */
export const saveAccessToken = (token) => {
  if (token) {
    sessionStorage.setItem("token_TSE", token);
  }
};

/**
 * Verifica si el usuario tiene un token válido
 *
 * @returns {boolean} True si existe un token
 */
export const hasValidToken = () => {
  return !!getAccessToken();
};

/**
 * Limpia toda la sesión del usuario
 */
export const clearSession = () => {
  sessionStorage.clear();
};
